<div class="deeplink-generator">
  <div class="page-header">
    <h2>{{ 'dg.title' | translate }}</h2>
    <a
      href="https://support.vitec-hotellinx.com/space/KB/276398228/Varausmoottori+-+Hakumaskin+integrointi+kotisivuille+ja+deeplinkit"
      target="_blank"
      rel="noopener noreferrer"
      class="docs-link">
      <i class="pi pi-external-link"></i> {{ 'dg.docsLink' | translate }}
    </a>
  </div>

  <p class="page-description">{{ 'dg.description' | translate }}</p>

  <div class="mode-tabs mb-3">
    <p-button
      [label]="'dg.roomBookingTab' | translate"
      [outlined]="mode !== 'room'"
      (onClick)="mode = 'room'"
    ></p-button>
    <p-button
      [label]="'dg.tableReservationTab' | translate"
      [outlined]="mode !== 'table'"
      (onClick)="mode = 'table'"
    ></p-button>
  </div>

  @if (mode === 'room') {
  <div [formGroup]="form">

  <div class="two-col-grid mb-3">

    <!-- Column 1 -->
    <div class="col">
      <label class="section-label">{{ 'dg.makeSearchLabel' | translate }}</label>
      <div class="field">
<!--         <p-checkbox formControlName="makeSearch" [binary]="true" inputId="makeSearch" />
         
 -->        
        

        <div class="flex gap-2">
            <label for="switch">{{ 'dg.dontMakeSearch' | translate }}</label>
            <p-toggleswitch formControlName="makeSearch" inputId="switch" />
            <label for="switch">{{ 'dg.makeSearch' | translate }}</label>
        </div>
      </div>
    </div>
  </div>

  <div class="two-col-grid">

    <!-- Column 1 -->
    <div class="col">

      

      <!-- Hotel -->
      <section class="form-section ">
        <label class="section-label">{{ 'dg.hotel' | translate }}</label>
        <p-select
          formControlName="hotelCode"
          [options]="hotels"
          optionLabel="label"
          optionValue="value"
          [placeholder]="'dg.selectHotel' | translate"
          styleClass="w-full" />
      </section>

      <!-- Arrival -->
      <section class="form-section">
        <label class="section-label">{{ 'dg.arrival' | translate }}</label>

        <div class="radio-row">
          <p-radiobutton formControlName="arrivalMode" value="date" inputId="arr-date" />
          <label for="arr-date">{{ 'dg.arrivalDate' | translate }}</label>
          @if (form.value.arrivalMode === 'date') {
            <p-datepicker [firstDayOfWeek]="1" formControlName="arrivalDate" dateFormat="dd.mm.yy" [showIcon]="true" />
          }
        </div>

        <div class="radio-row">
          <p-radiobutton formControlName="arrivalMode" value="today" inputId="arr-today" />
          <label for="arr-today">{{ 'dg.arrivalToday' | translate }}</label>
        </div>

        <div class="radio-row">
          <p-radiobutton formControlName="arrivalMode" value="tomorrow" inputId="arr-tomorrow" />
          <label for="arr-tomorrow">{{ 'dg.arrivalTomorrow' | translate }}</label>
        </div>

        <div class="radio-row">
          <p-radiobutton formControlName="arrivalMode" value="days" inputId="arr-days" />
          <label for="arr-days">{{ 'dg.arrivalDays' | translate }}</label>
          @if (form.value.arrivalMode === 'days') {
            <p-inputnumber formControlName="arrivalDays" [min]="1" [max]="365" placeholder="30" [showButtons]="true" />
          }
        </div>
      </section>

      <!-- Rooms -->
      <section class="form-section">
        <label class="section-label">{{ 'dg.rooms' | translate }}</label>

        @for (room of rooms; track $index; let ri = $index) {
          <div class="room-card">
            <div class="room-header">
              <strong>{{ 'dg.room' | translate:{ n: ri + 1 } }}</strong>
              @if (rooms.length > 1) {
                <p-button
                  icon="pi pi-times"
                  severity="secondary"
                  [text]="true"
                  [rounded]="true"
                  (onClick)="removeRoom(ri)" />
              }
            </div>

            <div class="room-fields">
              <div class="field">
                <label>{{ 'dg.adults' | translate }}</label>
                <p-inputnumber
                  [ngModel]="room.adults"
                  (ngModelChange)="updateRoomAdults(ri, $event)"
                  [ngModelOptions]="{standalone: true}"
                  [min]="1" [max]="10"
                  [showButtons]="true" />
              </div>
              <div class="field">
                <label>{{ 'dg.children' | translate }}</label>
                <p-inputnumber
                  [ngModel]="room.children"
                  (ngModelChange)="updateRoomChildren(ri, $event)"
                  [ngModelOptions]="{standalone: true}"
                  [min]="0" [max]="10"
                  [showButtons]="true" />
              </div>
            </div>

            @if (room.children > 0) {
              <div class="child-ages">
                <label>{{ 'dg.childAges' | translate }}</label>
                <div class="ages-row">
                  @for (age of room.childAges; track $index; let ai = $index) {
                    <p-inputnumber
                      [ngModel]="age"
                      (ngModelChange)="updateChildAge(ri, ai, $event)"
                      [ngModelOptions]="{standalone: true}"
                      [min]="0" [max]="17"
                      [placeholder]="'dg.child' | translate:{ n: ai + 1 }" />
                  }
                </div>
              </div>
            }
          </div>
        }

        <p-button
          [label]="'dg.addRoom' | translate"
          icon="pi pi-plus"
          severity="secondary"
          [disabled]="rooms.length >= 4"
          (onClick)="addRoom()" />
      </section>

    </div>

    <!-- Column 2 -->
    <div class="col">

      <!-- Language -->
      <section class="form-section">
        <label class="section-label">{{ 'dg.lang' | translate }}</label>
        @if (languageOptions.length > 0) {
          <p-select
            formControlName="lang"
            [options]="languageOptions"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'dg.selectLang' | translate"
            styleClass="w-full" />
        } @else {
          <input pInputText formControlName="lang" placeholder="fi" class="w-full" />
        }
      </section>

      <!-- Departure -->
      <section class="form-section">
        <label class="section-label">{{ 'dg.departure' | translate }}</label>

        <div class="radio-row">
          <p-radiobutton formControlName="departureMode" value="date" inputId="dep-date" />
          <label for="dep-date">{{ 'dg.departureDate' | translate }}</label>
          @if (form.value.departureMode === 'date') {
            <p-datepicker formControlName="departureDate" [firstDayOfWeek]="1" [minDate]="form.value.arrivalDate" [maxDate]="departureMaxDate" dateFormat="dd.mm.yy" [showIcon]="true" />
          }
        </div>

        <div class="radio-row">
          <p-radiobutton formControlName="departureMode" value="nights" inputId="dep-nights" />
          <label for="dep-nights">{{ 'dg.departureNights' | translate }}</label>
          @if (form.value.departureMode === 'nights') {
            <p-inputnumber formControlName="nroOfNights" [min]="1" [max]="maxStayNights" placeholder="1" [showButtons]="true" />
          }
        </div>
      </section>

      <!-- Advanced options -->
      <section class="form-section">
        <label class="section-label">{{ 'dg.advanced' | translate }}</label>

        @if (categoryOptions.length > 1) {
          <div class="field">
            <label>{{ 'dg.category' | translate }}</label>
            
              <p-select
                formControlName="category"
                [options]="categoryOptions"
                optionLabel="label"
                optionValue="value"
                [placeholder]="'dg.allCategories' | translate"
                styleClass="w-full" />
          </div>
        }

        <div class="field">
          <label>{{ 'dg.bookingCode' | translate }}</label>
          <input pInputText formControlName="bookingCode" />
        </div>

        <div class="field">
          <label>{{ 'dg.roomPriorityOrder' | translate }}</label>
          <input pInputText formControlName="roomPriorityOrder" placeholder="esim. 101,102,103" />
          <span class="field-hint">{{ 'dg.roomPriorityOrderHint' | translate }}</span>
        </div>

        <div class="field">
          <label>{{ 'dg.ratePriorityOrder' | translate }}</label>
          <input pInputText formControlName="ratePriorityOrder" placeholder="esim. 224,225,226" />
          <span class="field-hint">{{ 'dg.ratePriorityOrderHint' | translate }}</span>
        </div>

        
      </section>

    </div>

  </div>

  <!-- Generated URL — full width, sticky -->
  <section class="form-section url-section">
    <label class="section-label">{{ 'dg.generatedLink' | translate }}</label>
    <textarea pTextarea [value]="generatedUrl" readonly rows="2" class="url-textarea"></textarea>
    <p-button
      [label]="'dg.copyLink' | translate"
      icon="pi pi-copy"
      (onClick)="copyUrl(generatedUrl)" />
  </section>

  </div>
  }

  @if (mode === 'table') {
  <div [formGroup]="trForm">

  <div class="two-col-grid">

    <!-- Column 1 -->
    <div class="col">

      <!-- Restaurant -->
      <section class="form-section">
        <label class="section-label">{{ 'dg.trRestaurant' | translate }}</label>
        <p-select
          formControlName="eventSiteId"
          [options]="restaurants"
          optionLabel="label"
          optionValue="value"
          [placeholder]="'dg.trSelectRestaurant' | translate"
          styleClass="w-full" />
      </section>

      <!-- Guests -->
      <section class="form-section">
        <label class="section-label">{{ 'dg.trGuests' | translate }}</label>
        <p-inputnumber formControlName="guests" [min]="1" [max]="50" [showButtons]="true" />
      </section>

      <!-- Date -->
      <section class="form-section">
        <label class="section-label">{{ 'dg.trDate' | translate }}</label>

        <div class="radio-row">
          <p-radiobutton formControlName="dateMode" value="date" inputId="tr-date" />
          <label for="tr-date">{{ 'dg.arrivalDate' | translate }}</label>
          @if (trForm.value.dateMode === 'date') {
            <p-datepicker [firstDayOfWeek]="1" formControlName="date" dateFormat="dd.mm.yy" [showIcon]="true" />
          }
        </div>

        <div class="radio-row">
          <p-radiobutton formControlName="dateMode" value="today" inputId="tr-today" />
          <label for="tr-today">{{ 'dg.arrivalToday' | translate }}</label>
        </div>

        <div class="radio-row">
          <p-radiobutton formControlName="dateMode" value="tomorrow" inputId="tr-tomorrow" />
          <label for="tr-tomorrow">{{ 'dg.arrivalTomorrow' | translate }}</label>
        </div>

        <div class="radio-row">
          <p-radiobutton formControlName="dateMode" value="days" inputId="tr-days" />
          <label for="tr-days">{{ 'dg.arrivalDays' | translate }}</label>
          @if (trForm.value.dateMode === 'days') {
            <p-inputnumber formControlName="days" [min]="1" [max]="365" placeholder="30" [showButtons]="true" />
          }
        </div>
      </section>

    </div>

    <!-- Column 2 -->
    <div class="col">

      <!-- Event -->
      <section class="form-section">
        <label class="section-label">{{ 'dg.trEvent' | translate }}</label>
        <p-select
          formControlName="eventId"
          [options]="eventOptions"
          optionLabel="label"
          optionValue="value"
          [placeholder]="'dg.trSelectEvent' | translate"
          styleClass="w-full" />
      </section>

    </div>

  </div>

  <!-- Generated URL — full width, sticky -->
  <section class="form-section url-section">
    <label class="section-label">{{ 'dg.generatedLink' | translate }}</label>
    <textarea pTextarea [value]="generatedTableUrl" readonly rows="2" class="url-textarea"></textarea>
    <p-button
      [label]="'dg.copyLink' | translate"
      icon="pi pi-copy"
      (onClick)="copyUrl(generatedTableUrl)" />
  </section>

  </div>
  }
</div>
